const { createConstant } = require('../helpers')

// Check address, this might change
const service = 'prescription-service'

module.exports = {
  // For Admin Panel
  GET_PRESCRIPTION_LIST: createConstant(service, 'GET_PRESCRIPTION_LIST'),
  GET_PRESCRIPTION_LIST_SUCCESS: createConstant(service, 'GET_PRESCRIPTION_LIST_SUCCESS'),
  GET_PRESCRIPTION_LIST_ERROR: createConstant(service, 'GET_PRESCRIPTION_LIST_ERROR'),
  GET_PRESCRIPTION_LIST_RESET: createConstant(service, 'GET_PRESCRIPTION_LIST_RESET'),

  // For Admin Panel
  GET_PRESCRIPTION: createConstant(service, 'GET_PRESCRIPTION'),
  GET_PRESCRIPTION_SUCCESS: createConstant(service, 'GET_PRESCRIPTION_SUCCESS'),
  GET_PRESCRIPTION_ERROR: createConstant(service, 'GET_PRESCRIPTION_ERROR'),
  GET_PRESCRIPTION_RESET: createConstant(service, 'GET_PRESCRIPTION_RESET'),

  // For Admin Panel
  CREATE_PRESCRIPTION: createConstant(service, 'CREATE_PRESCRIPTION'),
  CREATE_PRESCRIPTION_SUCCESS: createConstant(service, 'CREATE_PRESCRIPTION_SUCCESS'),
  CREATE_PRESCRIPTION_ERROR: createConstant(service, 'CREATE_PRESCRIPTION_ERROR'),
  CREATE_PRESCRIPTION_RESET: createConstant(service, 'CREATE_PRESCRIPTION_RESET'),

  // For Admin Panel
  UPDATE_PRESCRIPTION: createConstant(service, 'UPDATE_PRESCRIPTION'),
  UPDATE_PRESCRIPTION_SUCCESS: createConstant(service, 'UPDATE_PRESCRIPTION_SUCCESS'),
  UPDATE_PRESCRIPTION_ERROR: createConstant(service, 'UPDATE_PRESCRIPTION_ERROR'),
  UPDATE_PRESCRIPTION_RESET: createConstant(service, 'UPDATE_PRESCRIPTION_RESET'),

  // For Admin Panel
  DELETE_PRESCRIPTION: createConstant(service, 'DELETE_PRESCRIPTION'),
  DELETE_PRESCRIPTION_SUCCESS: createConstant(service, 'DELETE_PRESCRIPTION_SUCCESS'),
  DELETE_PRESCRIPTION_ERROR: createConstant(service, 'DELETE_PRESCRIPTION_ERROR'),
  DELETE_PRESCRIPTION_RESET: createConstant(service, 'DELETE_PRESCRIPTION_RESET'),

  // For Admin Panel
  UPDATE_PRESCRIPTION_STATUS: createConstant(service, 'UPDATE_PRESCRIPTION_STATUS'),
  UPDATE_PRESCRIPTION_STATUS_SUCCESS: createConstant(service, 'UPDATE_PRESCRIPTION_STATUS_SUCCESS'),
  UPDATE_PRESCRIPTION_STATUS_ERROR: createConstant(service, 'UPDATE_PRESCRIPTION_STATUS_ERROR'),
  UPDATE_PRESCRIPTION_STATUS_RESET: createConstant(service, 'UPDATE_PRESCRIPTION_STATUS_RESET'),

  // For Admin Panel
  ADD_PRESCRIPTION_VALIDITY: createConstant(service, 'ADD_PRESCRIPTION_VALIDITY'),
  ADD_PRESCRIPTION_VALIDITY_SUCCESS: createConstant(service, 'ADD_PRESCRIPTION_VALIDITY_SUCCESS'),
  ADD_PRESCRIPTION_VALIDITY_ERROR: createConstant(service, 'ADD_PRESCRIPTION_VALIDITY_ERROR'),
  ADD_PRESCRIPTION_VALIDITY_RESET: createConstant(service, 'ADD_PRESCRIPTION_VALIDITY_RESET'),

  POST_DOCTOR_PRESCRIPTION_SEARCH_DATA: createConstant(service, 'POST_DOCTOR_PRESCRIPTION_SEARCH_DATA'),
  POST_DOCTOR_PRESCRIPTION_SEARCH_DATA_SUCCESS: createConstant(service, 'POST_DOCTOR_PRESCRIPTION_SEARCH_DATA_SUCCESS'),
  POST_DOCTOR_PRESCRIPTION_SEARCH_DATA_ERROR: createConstant(service, 'POST_DOCTOR_PRESCRIPTION_SEARCH_DATA_ERROR'),
  POST_DOCTOR_PRESCRIPTION_SEARCH_DATA_RESET: createConstant(service, 'POST_DOCTOR_PRESCRIPTION_SEARCH_DATA_RESET'),

  POST_DOCTOR_PRESCRIPTION_DATA: createConstant(service, 'POST_DOCTOR_PRESCRIPTION_DATA'),
  POST_DOCTOR_PRESCRIPTION_DATA_SUCCESS: createConstant(service, 'POST_DOCTOR_PRESCRIPTION_DATA_SUCCESS'),
  POST_DOCTOR_PRESCRIPTION_DATA_ERROR: createConstant(service, 'POST_DOCTOR_PRESCRIPTION_DATA_ERROR'),
  POST_DOCTOR_PRESCRIPTION_DATA_RESET: createConstant(service, 'POST_DOCTOR_PRESCRIPTION_DATA_RESET'),

  GET_MD_PRESCRIPTION_NEW_LINK: createConstant(service, 'GET_MD_PRESCRIPTION_NEW_LINK'),
  GET_MD_PRESCRIPTION_NEW_LINK_SUCCESS: createConstant(service, 'GET_MD_PRESCRIPTION_NEW_LINK_SUCCESS'),
  GET_MD_PRESCRIPTION_NEW_LINK_ERROR: createConstant(service, 'GET_MD_PRESCRIPTION_NEW_LINK_ERROR'),
  GET_MD_PRESCRIPTION_NEW_LINK_RESET: createConstant(service, 'GET_MD_PRESCRIPTION_NEW_LINK_RESET'),

  POST_DOCTOR_EDIT_PRESCRIPTION_SEARCH_DATA: createConstant(service, 'POST_DOCTOR_EDIT_PRESCRIPTION_SEARCH_DATA'),
  POST_DOCTOR_EDIT_PRESCRIPTION_SEARCH_DATA_SUCCESS: createConstant(service, 'POST_DOCTOR_EDIT_PRESCRIPTION_SEARCH_DATA_SUCCESS'),
  POST_DOCTOR_EDIT_PRESCRIPTION_SEARCH_DATA_ERROR: createConstant(service, 'POST_DOCTOR_EDIT_PRESCRIPTION_SEARCH_DATA_ERROR'),
  POST_DOCTOR_EDIT_PRESCRIPTION_SEARCH_DATA_RESET: createConstant(service, 'POST_DOCTOR_EDIT_PRESCRIPTION_SEARCH_DATA_RESET'),

  GET_PATIENT_PRESCRIPTION_DATA: createConstant(service, 'GET_PATIENT_PRESCRIPTION_DATA'),
  GET_PATIENT_PRESCRIPTION_DATA_SUCCESS: createConstant(service, 'GET_PATIENT_PRESCRIPTION_DATA_SUCCESS'),
  GET_PATIENT_PRESCRIPTION_DATA_ERROR: createConstant(service, 'GET_PATIENT_PRESCRIPTION_DATA_ERROR'),
  GET_PATIENT_PRESCRIPTION_DATA_RESET: createConstant(service, 'GET_PATIENT_PRESCRIPTION_DATA_RESET'),

  POST_FOR_PRESCRIPTION_NOTIFICATION: createConstant(service, 'POST_FOR_PRESCRIPTION_NOTIFICATION'),
  POST_FOR_PRESCRIPTION_NOTIFICATION_SUCCESS: createConstant(service, 'POST_FOR_PRESCRIPTION_NOTIFICATION_SUCCESS'),
  POST_FOR_PRESCRIPTION_NOTIFICATION_ERROR: createConstant(service, 'POST_FOR_PRESCRIPTION_NOTIFICATION_ERROR'),
  POST_FOR_PRESCRIPTION_NOTIFICATION_RESET: createConstant(service, 'POST_FOR_PRESCRIPTION_NOTIFICATION_RESET'),
}
